import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../../components/common/table/table';
import Role from '../../../interfaces/role';
import {
  INTERNAL_ROLES_CREATE,
  INTERNAL_ROLES_VIEW,
} from '../../../router/routes';
import { useService } from '../../../services/services';
import css from './index.module.css';
import { LinkComponent as Link } from '../../../components/form/elements/link';
import Title from '../../../components/common/title';

export default function Roles() {
  const { t } = useTranslation();
  const { roleService } = useService();

  return (
    <div className={css['index']}>
      <Title title={t('Roles')} />
      <div className={css['body']}>
        <div className={css['toolbar']}>
          <Link
            label="add"
            primary={true}
            linkTo={INTERNAL_ROLES_CREATE}
            icon={faPlus}
          />
        </div>
        <Table<Role>
          request={(page, sort, desc) => roleService.index(page, sort, desc)}
          keyAccessor="id"
          columns={[
            { accessor: 'name', header: t('name'), sortable: true },
            { accessor: 'title', header: t('title'), sortable: true },
          ]}
          viewRoute={INTERNAL_ROLES_VIEW}
          viewRecordAbility={{ title: 'Manage roles' }}
        />
      </div>
    </div>
  );
}
